import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type SettingSpotConfiguration } from '@clean-code/models';
import {
  DataTableParameters,
  ID,
} from '@clean-code/models/common';
import {
  HttpResponseHelper,
} from '@clean-code/shared/common';
import { ConfigService } from '@clean-code/shared/util-config';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import {
  DataServiceReturn,
  EditSearchDataService,
} from '@clean-code/shared/util/util-data-service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class SettingSpotConfigurationService
  implements EditSearchDataService<SettingSpotConfiguration>
{
  private uploadUrl = this.configService.settings['api'] + 'setting/';

  private readonly entityFields = `
    id
    country
    energySource
    stockMarket
  `;

  constructor(
    private graphqlService: GraphqlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
  ) {}
  getAll$(
    params?: DataTableParameters,
  ): Observable<DataServiceReturn<SettingSpotConfiguration>> {
    throw new Error('Method not implemented.');
  }

  public getAllSettingSpotConfigurations$(
    energySource: 'POWER' | 'GAS' = null,
  ): Observable<SettingSpotConfiguration[]> {

    const where = energySource ? `where: { energySource: { eq: ${energySource} }}` : '';
    const query = `
        query
        {
            settingSpotConfigurationGetAll(${where}) {
                id
                country
                energySource
                stockMarket
            }
        }
    `;

    const variables = {
      energySource,
    };

    return this.graphqlService.query<SettingSpotConfiguration[]>(
      query,
      energySource ? variables : null,
    );
  }

  public getById$(id: ID): Observable<SettingSpotConfiguration> {
    const where = `where: { id: { eq: ${id} }}`;
    const query = `
        query
        {
            settingSpotConfigurationGetById(${where}) {
                id
                country
                energySource
                stockMarket
            }
        }
    `;
    return this.graphqlService.singleQuery<SettingSpotConfiguration>(
      query,
    );
  }

  public add$(
    settingSpotConfiguration: SettingSpotConfiguration,
  ): Observable<boolean> {
    const input = {
      country: settingSpotConfiguration.country,
      energySource: settingSpotConfiguration.energySource,
      stockMarket: settingSpotConfiguration.stockMarket,
    };

    const mutation = `
        mutation ($input: SettingSpotConfigurationAddUpdateInput!){
          addSettingSpotConfiguration(input: $input)
        }`;

    return this.graphqlService.query<boolean>(mutation, { input });
  }

  public update$(
    settingSpotConfiguration: SettingSpotConfiguration,
  ): Observable<boolean> {
    const input = {
      id: +settingSpotConfiguration.id,
      country: settingSpotConfiguration.country,
      energySource: settingSpotConfiguration.energySource,
      stockMarket: settingSpotConfiguration.stockMarket,
    };

    const mutation = `
        mutation ($input: SettingSpotConfigurationAddUpdateInput!){
          updateSettingSpotConfiguration(input: $input)
        }`;

    return this.graphqlService.query<boolean>(mutation, { input });
  }

  public delete$(id: ID): Observable<boolean> {
    const mutation = `
        mutation ($id: Int!){
          deleteSettingSpotConfiguration(id: $id)
          }`;

    return this.graphqlService.mutation<boolean>(mutation, { id });
  }

  public exportSpotConfgiurationResultToExcel$(id: ID): Observable<boolean> {
    const headers = new HttpHeaders({
      'Access-Control-Expose-Headers': 'Content-Disposition',
    });

    return this.httpClient
      .get(this.uploadUrl + '' + id + '/export', {
        responseType: 'blob' as 'json',
        observe: 'response',
        headers: headers,
      })
      .pipe(
        tap((response: HttpResponse<object>) => {
          const fileName = HttpResponseHelper.getHttpResponseFileName(response);
          const url = window.URL.createObjectURL(response.body as Blob);
          const anchor = document.createElement('a');
          anchor.download = fileName;
          anchor.href = url;
          anchor.click();
        }),
        map(() => true),
        catchError((error: any) => {
          return throwError(error);
        }),
      );
  }
}
